module.exports = __webpack_public_path__ + "img/more.103ffe9f.svg";